import type { TriggerProfileView } from '@/lib/api/generated/model';
import { matchesName } from '@/shared/utils/matchesName';

export type TriggerStateFilter = 'all' | 'enabled' | 'disabled';

/** The chip and the text combine (spec 229 FR-008): both must hold. */
export function filterTriggers(
  profiles: TriggerProfileView[],
  query: string,
  state: TriggerStateFilter,
): TriggerProfileView[] {
  return profiles.filter(
    (profile) =>
      (state === 'all' || profile.enabled === (state === 'enabled')) &&
      matchesName(profile.name, query),
  );
}

/** Chip counts over the whole list, never the filtered one (spec Assumptions). */
export function triggerCounts(
  profiles: TriggerProfileView[],
): Record<TriggerStateFilter, number> {
  const enabled = profiles.filter((profile) => profile.enabled).length;
  return { all: profiles.length, enabled, disabled: profiles.length - enabled };
}
